module.exports = __webpack_public_path__ + "img/4.7c5c9474.jpg";